import type { ModerationState } from '@mmf/contracts';

/**
 * Copy for the "only you can see this" badge shown to an item's own author
 * when it isn't visible to anyone else. PendingReview (still awaiting a
 * moderator's decision — may yet be approved) and Rejected (a moderator has
 * already decided against it — this won't come back) are different enough
 * situations that the same "awaiting review" wording for both would wrongly
 * suggest a rejected post is still pending. Published (and the practically
 * unreachable Removed, which no query ever returns to its own author) render
 * nothing.
 */
export function moderationBadgeText(state: ModerationState): string | null {
  if (state === 'PendingReview') {
    return 'awaiting review — only you can see this';
  }
  if (state === 'Rejected') {
    return 'rejected by a moderator — only you can see this';
  }
  return null;
}

/**
 * Same distinction, shorter — for FeaturedTopics' dense preview list rather
 * than a single full-width row (TopicList/TopicDetail/CommentThread, which
 * use the fuller text above). Drops "by a moderator"/"awaiting review" but
 * keeps "only you can see this" in full — that's the one part of the
 * message that actually matters here (it's what stops a viewer wondering
 * why they can see something nobody else can).
 */
export function moderationBadgeShortText(state: ModerationState): string | null {
  if (state === 'PendingReview') {
    return 'pending — only you can see this';
  }
  if (state === 'Rejected') {
    return 'rejected — only you can see this';
  }
  return null;
}
